<template>
  <div class="checkbox">
    <input
      type="checkbox"
      :name="name"
      :id="name.toUpperCase()"
      class="checkbox__input"
      @change="changeHandler"
      :value="value"
      v-model="model"
    />
    <label
      class="checkbox__wrapper"
      :for="name.toUpperCase()"
    >
      <div
        class="checkbox__checkmark"
        :class="{ 'checkbox__checkmark--checked': model }"
      >
        <div class="checkbox__checkmark--icon-wrapper">
          <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4.93997L3.4 7.33997L9 1.33997" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <span v-html="label"></span>
    </label>
  </div>
</template>

<script setup lang="ts">
import type { ICheckbox } from '../../types/checkbox.types';
import { E_CHECKBOX_EVENT } from '../../types/components-events.enums';
import type { TCheckboxEventResponse } from '../../types/event-response.types';

const props = defineProps<ICheckbox>();

const emit = defineEmits<{
  (event: E_CHECKBOX_EVENT.UPDATE_MODEL_VALUE, value: TCheckboxEventResponse[E_CHECKBOX_EVENT.UPDATE_MODEL_VALUE]): void;
}>();

const model = defineModel<ICheckbox['value']>();

function changeHandler() {
  if (model.value) {
    emit(E_CHECKBOX_EVENT.UPDATE_MODEL_VALUE, {
      name: props.name,
      value: model.value,
    });
  }
}
</script>

<style scoped lang="scss">
.checkbox {
  position: relative;

  &__wrapper {
    display: flex;
    gap: 8px;
    cursor: pointer;
  }

  &__input {
    display: none;
    position: absolute;
    z-index: -1;
  }

  &__checkmark {
    display: flex;
    justify-content: center;
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    transition: all 0.3s;

    &--icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &--checked {
      border-color: $brand-color;
      background-color: $brand-color;
      border-radius: 0;
    }
  }
}
</style>